module.exports = __webpack_public_path__ + "static/media/5.f6c82d0e.jpg";